export default "__VITE_ASSET__scNqoGjY__"